import { removeItemOptimistically } from '../utils/quote-helpers';
import { useQuoteMutation } from './create-quote-mutation';

type ItemType = 'product' | 'section';

interface RemoveQuoteItemVariables {
  itemId: string;
  itemType?: ItemType;
}

/**
 * Remove any item (product or section) from quote with optimistic updates
 */
export const useRemoveQuoteItem = (quoteId: string) =>
  useQuoteMutation<RemoveQuoteItemVariables>({
    quoteId,
    optimisticUpdate: (quote, { itemId }) =>
      removeItemOptimistically(quote, itemId)
  });
